/**
 *
 * Shared functionality to do with locations
 *
 * @author Crstian S. (cstafie@yext.com)
 *
 */
goog.module('yext.location.util');
goog.module.declareLegacyNamespace();


/**
 * Build localized location address
 *
 * @param {!Object} location Location details
 * @param {string} lineBreak can optionally changed what is used for line breaks
 * @return {string} string of localized location address
 */
function buildLocationAddress(location, lineBreak) {
  lineBreak = typeof lineBreak !== 'undefined' ? lineBreak : '<br/>';
  var text = '';

  for (var i = 0; i < location.fields.length; i++) {
    for (var j = 0; j < location.fields[i].length; j++) {
      text += location.fields[i][j].value +
                (location.fields[i][j].comma ? ', ' : ' ');
    }
    text += lineBreak;
  }
  return text;
}
goog.exportSymbol('yext.location.util.buildLocationAddress', buildLocationAddress);

const formattedFieldNames = {
  'name': yext.msg('Business Name'),
  'description': yext.msg('Business Description'),
  'specialOffer.url': yext.msg('Featured Message URL'),
  'specialOffer.description': yext.msg('Featured Message Description'),
  'externalUrl.url': yext.msg('Website URL'),
  'externalUrl.displayUrl': yext.msg('Website Display URL'),
};

/**
 * Formats a field name using the formattedFieldNames map, and otherwise
 * assuming it is a custom field
 *
 * @param {string} fieldName The relevant field name
 * @return {string} Formatted field name
 */
function formatFieldName(fieldName) {
  var formatted = formattedFieldNames[fieldName];
  if (!formatted) {
    // TODO(cbreezy): Deal with custom field names a little better
    formatted = yext.msg('Custom Field');
  }
  return formatted;
}

exports = {
  buildLocationAddress,
  formattedFieldNames,
  formatFieldName,
};
